import type { TimelineItem } from '../types/content'

export const careerTimeline: TimelineItem[] = [
  {
    year: '2019',
    title: 'First race season',
    description: 'Em started racing at age 14 in Junior Sedans behind the wheel of a Daihatsu Charade.',
  },
  {
    year: '2020–22',
    title: 'Wins and podiums',
    description: 'After moving into a Mitsubishi Mirage, Em built a record of race wins, consistent podiums and strong Blue-Ribbon results.',
  },
  {
    year: 'Junior finale',
    title: 'Top-five result',
    description: 'Em finished fifth in the Junior Sedan All Star Series and earned the Junior Sedan Top Star Club Champion title.',
  },
  {
    year: '2023',
    title: 'Senior debut',
    description: 'Em stepped into the senior division and made her debut in the SSA Production Sedan class.',
  },
  {
    year: '2024–25',
    title: 'Building consistency',
    description: 'More seat time and support from experienced drivers helped Em build confidence and consistency in the senior field.',
  },
  {
    year: '2026/27',
    title: 'The next chapter',
    description: 'The focus is more racing, stronger partnerships and continued development in the #7 Production Sedan.',
  },
]

export const achievements = [
  'Race wins across three junior seasons',
  'Consistent podium finishes',
  'Strong results at local and Blue-Ribbon events',
  '5th in the Junior Sedan All Star Series',
  'Junior Sedan Top Star Club Champion',
  'Senior SSA Production Sedan debut in 2023',
]
